

import React from "react";

const vehicles = [
  {
    id: 1,
    name: "Hyundai Aura",
    image: "images/fleets/Aura.jpg",
    category: "cat-1",
    seats: 4,
    bags: 4,
    suv: 0,
    fuel: ["Petrol", "Diesel"],
  },
  {
    id: 3,
    name: "Maruti Dzire",
    image: "images/fleets/Dzire.jpg",
    category: "cat-1",
    seats: 4,
    bags: 4,
    suv: 0,
    fuel: ["Petrol", "Diesel"],
  },
  {
    id: 4,
    name: "Maruti Ertiga",
    image: "images/fleets/Ertiga.jpg",
    category: "cat-2",
    seats: 6,
    bags: 6,
    suv: 0,
    fuel: ["Petrol", "Diesel"],
  },
  {
    id: 7,
    name: "Kia Carens",
    image: "images/fleets/Kia.jpg",
    category: "cat-2",
    seats: 6,
    bags: 6,
    suv: 0,
    fuel: ["Petrol", "Diesel"],
  },
  // {
  //   id: 5,
  //   name: "Innova",
  //   image: "images/fleets/Innova.jpg",
  //   category: "cat-3",
  //   seats: 7,
  //   bags: 7,
  //   suv: 1,
  //   fuel: ["Diesel"],
  // },
  {
    id: 6,
    name: "Innova Crysta",
    image: "images/fleets/Innova-Crysta.jpg",
    category: "cat-4",
    seats: 7,
    bags: 7,
    suv: 1,
    fuel: ["Diesel"],
  },
    {
    id: 2,
    name: "Mini Bus",
    image: "images/fleets/Bus.jpg",
    category: "cat-2",
    seats: 20,
    bags: 15,
    suv: 0,
    fuel: ["Diesel"],
  },
  {
    id: 9,
    name: "Urbania",
    image: "images/fleets/urbania.jpg",
    category: "cat-4",
    seats: 9,
    bags: 6,
    suv: 0,
    fuel: ["Diesel"],
  },
  {
    id: 8,
    name: "Tempo Traveller",
    image: "images/fleets/Tempo-traveler.jpg",
    category: "cat-3",
    seats: 14,
    bags: 12,
    suv: 0,
    fuel: ["Diesel"],
  },
  {
    id: 2,
    name: "Bus",
    image: "images/fleets/Bus.jpg",
    category: "cat-2",
    seats: 32,
    bags: 15,
    suv: 0,
    fuel: ["Diesel"],
  },
];

const Booking = () => {
  const phoneNumber = "+919689815477"; // WhatsApp number

  const handleBookNow = (carName) => {
    const message = `Hi, I want to book ${carName}.`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">Online Booking</h2>
            </div>
          </div>
        </div>
      </div>

    <div className="section-full py-5 site-bg-white twm-cars-section-wrap">
      <div className="container">
        {/* <div className="section-head center">
          <div className="twm-sm-title left">Our Fleet</div>
          <h2 className="twm-large-title site-text-dark">Book Your Ride</h2>
        </div> */}

        <div className="section-content">
          <div className="row">
            {vehicles.map((vehicle) => (
              <div key={vehicle.id} className="col-lg-4 col-md-6 m-b30">
                <div className="twm-vehicle-fleet-bx twm-custom-grid-3 text-center ">
                  <div className="twm-media ">
                    <img src={vehicle.image} alt={vehicle.name} />
                  </div>
                  <div className="twm-vehicle-fleet-content borr">
                    <h3 className="twm-v-title">{vehicle.name}</h3>
                    <ul className="twm-vehicle-facility">
                      <li><i className="fa fa-user"></i> &nbsp;{vehicle.seats} Seats</li>
                      <li><i className="fa fa-suitcase"></i>&nbsp; {vehicle.bags} Bags</li>
                      {/* {vehicle.suv ? <li><i className="fa fa-car"></i>&nbsp; SUV</li> : null} */}
                      <li><i className="fa fa-tachometer"></i>&nbsp; {vehicle.fuel.join(", ")}</li>
                    </ul>
                    <button
                      className="book-now-btn"
                      onClick={() => handleBookNow(vehicle.name)}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    
    </>
  );
};

export default Booking;